Vue.component('lookbookOrder', {
  data() {
    return {
      sortedShopList: [],
    };
  },
    methods: {

    sortedShopName(shop) {
            if (shop.name.endsWith(shop.city)) {
                return `${shop.name} - (${shop.distance}km)`;
            } else {
                return `${shop.name} - ${shop.city} - (${shop.distance}km)`;
            }
    },
    sortShoplistByZipcode(e) {

      let sortShopList = false;

      var city = document.forms['lookbook-order-form'].elements.City.value;
      var zipcode = document.forms['lookbook-order-form'].elements.PostalCode.value;

      if (!website.loggedIn) {
        sortShopList = true;
      }

      if (website.loggedIn
                && (!document.forms['lookbook-order-form'].elements.PostalCode.readOnly
                && document.forms['lookbook-order-form'].elements.CustomerNumber.value === '')) {
        sortShopList = true;
      }

      if (sortShopList && zipcode.length > 0) {
          fetch(`/api/geolocation/shops?zipcode=${zipcode}&city=${encodeURIComponent(city)}`, {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': document.documentElement.lang,
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
        }).then(response => response.json()).then((shops) => {
          this.sortedShopList = shops;

          Vue.nextTick(() => {
            fInitCustomSelects();
          });
        });
      }
    },
  },
});
